import { IState } from '../../store';

export const selectIsSuccessModalOpen = (state: IState) => state.requestDemand.isSuccessModalOpen;
